var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnchor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "anchor",
    "data-name": "Layer 1",
    viewBox: "0 0 386.85 386.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-234.68 -243.87)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.1,
    y: 328.84,
    width: 151,
    height: 286.47,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-234.68 -243.87)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.11,
    y: 328.84,
    width: 151,
    height: 286.47,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_Mirror_Repeat_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.11,615.31c-13-37.38-103.18-30-137.16-140.35-4.07,1.83-13.85,4.66-13.85,4.66l16.26-69.83,43.78,53.48-15.73,2.66c-1.9,26.81,90.73,138.56,90,22.57-.15-24.83-.45-116.17-.45-116.17H375.54L372,347.23l37.91-2.83-1.14-10.5,3.25-3.08,18.38-2",
    transform: "translate(-234.68 -243.87)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Mirror_Repeat_2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428.11,615.31c13-37.38,103.17-30,137.15-140.35,4.08,1.83,13.85,4.66,13.85,4.66l-16.26-69.83-43.78,53.48,15.73,2.66c1.91,26.81-90.73,138.56-90,22.57.15-24.83.44-116.17.44-116.17h35.45l3.54-25.1L446.3,344.4l1.14-10.5-3.25-3.08-18.38-2",
    transform: "translate(-234.68 -243.87)"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M428.27,258.31a36.26,36.26,0,1,0,36.25,36.26A36.25,36.25,0,0,0,428.27,258.31Zm0,53A16.78,16.78,0,1,1,445,294.57,16.77,16.77,0,0,1,428.27,311.34Z",
    transform: "translate(-234.68 -243.87)"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 386.85,
    height: 386.85,
    style: {
      fill: "none"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor);
export default __webpack_public_path__ + "static/media/anchor.3357ef0343e211a3b0bf5f22798379dc.svg";
export { ForwardRef as ReactComponent };